import SvgIcon from '@/components/SvgIcon';

const style = { verticalAlign: 'sub' };

const ArrowLeft = (props) => {
  const svg = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.65284 4.05301C8.94573 3.76012 9.42061 3.76012 9.7135 4.05301C9.97977 4.31928 10.004 4.73594 9.78612 5.02956L9.7135 5.11367L6.9095 7.91668L9.7135 10.7197C9.97977 10.9859 10.004 11.4026 9.78612 11.6962L9.7135 11.7803C9.44723 12.0466 9.03057 12.0708 8.73696 11.853L8.65284 11.7803L5.71234 8.83984C5.23648 8.36398 5.20476 7.61217 5.61717 7.09952L5.71234 6.99351L8.65284 4.05301Z"
        fill="currentColor"
      />
    </svg>
  );
  return <SvgIcon component={svg} style={{ ...style }} {...props} />;
};
const ArrowRight = (props) => {
  return (
    <ArrowLeft style={{ ...style, transform: 'rotate(180deg)' }} {...props} />
  );
};

export { ArrowLeft, ArrowRight };
